import React from "react";
export const CheckSuccess = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1309_17197)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.99992 1.83331C4.59416 1.83331 1.83325 4.59422 1.83325 7.99998C1.83325 11.4057 4.59416 14.1666 7.99992 14.1666C11.4057 14.1666 14.1666 11.4057 14.1666 7.99998C14.1666 4.59422 11.4057 1.83331 7.99992 1.83331ZM0.833252 7.99998C0.833252 4.04194 4.04188 0.833313 7.99992 0.833313C11.958 0.833313 15.1666 4.04194 15.1666 7.99998C15.1666 11.958 11.958 15.1666 7.99992 15.1666C4.04188 15.1666 0.833252 11.958 0.833252 7.99998ZM11.3535 5.64643C11.5487 5.84169 11.5487 6.15827 11.3535 6.35353L7.35347 10.3535C7.15821 10.5488 6.84163 10.5488 6.64637 10.3535L4.64637 8.35353C4.4511 8.15827 4.4511 7.84169 4.64637 7.64643C4.84163 7.45116 5.15821 7.45116 5.35347 7.64643L6.99992 9.29287L10.6464 5.64643C10.8416 5.45116 11.1582 5.45116 11.3535 5.64643Z"
          fill="#2BA682"
        />
      </g>
      <defs>
        <clipPath id="clip0_1309_17197">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
